(() => {
  if (customElements.get('vv-whatsapp-consent')) return;
  const key = 'vv_whatsapp_consent';
  const version = 'vv-cart-whatsapp-v3';
  const consentText = 'Quiero recibir por WhatsApp atención personalizada para mi compra, recordatorios de mi carrito, una bienvenida después de comprar, novedades, lanzamientos y promociones de Vaquero Vaquera. Puedo darme de baja cuando quiera.';
  const instances = new Set();
  let state, busy = false, message = '';
  const parse = value => { try { const data = JSON.parse(value || '{}'); return data.version === version ? data : {}; } catch { return {}; } };
  const sync = () => instances.forEach(el => {
    el.input.checked = state?.status === 'granted';
    el.input.disabled = busy;
    el.dataset.selected = String(el.input.checked);
    el.setAttribute('aria-busy', String(busy));
    el.querySelector('.vv-wa__status').textContent = message;
  });
  class WhatsAppConsent extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;
      if (state === undefined) state = parse(this.dataset.consent);
      instances.add(this);
      this.hidden = false;
      this.onChange = () => this.save();
      this.input.addEventListener('change', this.onChange);
      sync();
    }
    disconnectedCallback() { instances.delete(this); this.input?.removeEventListener('change', this.onChange); }
    async save() {
      if (busy) { sync(); return; }
      const desired = { version, scopes: ['purchase_help', 'cart_recovery', 'postpurchase_welcome', 'marketing'], status: this.input.checked ? 'granted' : 'declined', updated_at: new Date().toISOString(), text: consentText, source: this.dataset.source };
      busy = true; message = 'Guardando tu elección…'; sync();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [key]: JSON.stringify(desired) } }), signal: AbortSignal.timeout(12000)
        });
        if (!response.ok) throw new Error('save_failed');
        const cart = await response.json();
        const saved = parse(cart.attributes?.[key]);
        if (saved.status !== desired.status || saved.updated_at !== desired.updated_at) throw new Error('not_confirmed');
        state = saved;
        message = saved.status === 'granted' ? 'Listo. Guardamos tu autorización.' : 'Listo. Guardamos tu elección de no recibir estos mensajes.';
      } catch {
        // Reconcile an uncertain write; never display success without a server response.
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
          if (response.ok) state = parse((await response.json()).attributes?.[key]);
        } catch { /* Keep last confirmed state. */ }
        message = 'No pudimos confirmar el cambio. Revisa la casilla e inténtalo de nuevo.';
      } finally { busy = false; sync(); }
    }
  }
  customElements.define('vv-whatsapp-consent', WhatsAppConsent);
  // Keep a checkout navigation from racing a pending preference write.
  const pauseCheckout = event => {
    if (!busy) return;
    const checkout = event.type === 'submit' ? event.submitter?.matches('[name="checkout"]') : event.target.closest('[name="checkout"],a[href*="/checkout"],.additional-checkout-buttons');
    if (checkout) { event.preventDefault(); event.stopImmediatePropagation(); message = 'Estamos guardando tu elección. En un momento puedes continuar.'; sync(); }
  };
  document.addEventListener('click', pauseCheckout, true);
  document.addEventListener('submit', pauseCheckout, true);
})();
